import { AxiosResponse } from 'axios';
import { HttpClient } from '../../../HttpClient';
import { SignalApiUrls } from '../../../urls';
import {
  LocationAttributes,
  MonitorApiPayload,
} from '../components/AddMonitor/types';
import {
  AutonomousMonitor,
  AutonomousMonitorDetailed,
  FilterData,
  Monitor,
} from '../types';

export default class MonitorsClient extends HttpClient {
  async fetchMonitorListItems(
    partnerId: string,
  ): Promise<AxiosResponse<Monitor[]>> {
    const response = await this.get<AxiosResponse<Monitor[]>>(
      SignalApiUrls.getMonitorsUrl(partnerId),
    );
    return response;
  }

  async deleteMonitor(partnerId: string, monitorId: string): Promise<void> {
    await this.delete<AxiosResponse<void>>(
      SignalApiUrls.getIndividualMonitorUrl(partnerId, monitorId),
    );
  }

  async getMonitor(
    partnerId: string,
    monitorId: string,
  ): Promise<AxiosResponse<Monitor>> {
    const response = await this.get<AxiosResponse<Monitor>>(
      SignalApiUrls.getIndividualMonitorUrl(partnerId, monitorId),
    );
    return response;
  }

  async createMonitor(
    partnerId: string,
    monitor: MonitorApiPayload,
  ): Promise<AxiosResponse<Monitor>> {
    const response = await this.post<AxiosResponse<Monitor>>(
      SignalApiUrls.createMonitorUrl(partnerId),
      monitor,
    );
    return response;
  }

  async updateMonitor(
    partnerId: string,
    monitorId: string,
    monitor: Partial<Monitor>,
  ): Promise<AxiosResponse<Monitor>> {
    const response = await this.patch<AxiosResponse<Monitor>>(
      SignalApiUrls.updateMonitorUrl(partnerId, monitorId),
      monitor,
    );
    return response;
  }

  async getDynamicFilter(
    partnerId: string,
    filters: LocationAttributes,
  ): Promise<AxiosResponse<FilterData>> {
    const response = await this.post<AxiosResponse<FilterData>>(
      SignalApiUrls.getDynamicFilterData(partnerId),
      filters,
    );
    return response;
  }

  async getAutonomousMonitorsList(partnerId: string) {
    const response = await this.get<AxiosResponse<AutonomousMonitor[]>>(
      SignalApiUrls.getAutonomousMonitorsList(partnerId),
    );
    return response;
  }

  async getAutonomousMonitor(partnerId: string, monitorId: string) {
    const response = await this.get<AxiosResponse<AutonomousMonitorDetailed>>(
      SignalApiUrls.getAutonomousMonitor(partnerId, monitorId),
    );
    return response;
  }
}
